module.exports = __webpack_public_path__ + "static/img/bg_img_empty@2x.1ce1d3d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/default/bg_img_empty@2x.png
// module id = eCVq
// module chunks = 1